import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

/** Polls a contest leaderboard. Own the hook once per page and pass `data` down. */
export default function useLiveLeaderboard(contestId, { refreshMs = 15000, enabled = true } = {}) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!contestId || !enabled) return undefined;
    let cancelled = false;
    const load = async () => {
      try {
        const { data: res } = await api.get(`/contests/${contestId}/leaderboard`);
        if (!cancelled) {
          setData(res);
          setError(null);
        }
      } catch (e) {
        if (!cancelled) setError("Failed to load leaderboard");
      }
    };
    load();
    const timer = setInterval(load, refreshMs);
    return () => { cancelled = true; clearInterval(timer); };
  }, [contestId, refreshMs, enabled]);

  return { data, error };
}
